import React, { useEffect, useRef, useState } from "react";
import { CheckIcon, CopyIcon } from "./TriloChatIcons";
import { copyResponse } from "../utils/triloChatCopy";

const COPIED_RESET_MS = 2000;

/**
 * TriloChatCopyButton
 *
 * Icon button in the top-right corner of an assistant bubble. Copies the reply
 * as rich text (see utils/triloChatCopy.js) and briefly shows a tick.
 *
 * Props:
 * - content: Raw reply text
 */
const TriloChatCopyButton = ({ content }) => {
  const [copied, setCopied] = useState(false);
  const resetTimer = useRef(null);

  useEffect(() => () => clearTimeout(resetTimer.current), []);

  const handleCopy = async () => {
    if (!(await copyResponse(content))) return;
    setCopied(true);
    clearTimeout(resetTimer.current);
    resetTimer.current = setTimeout(() => setCopied(false), COPIED_RESET_MS);
  };

  const label = copied ? "Copied" : "Copy response";
  return (
    <button
      type="button"
      className={`trilochat__copy-btn${copied ? " trilochat__copy-btn--copied" : ""}`}
      title={label}
      aria-label={label}
      onClick={handleCopy}>
      {copied ? <CheckIcon /> : <CopyIcon />}
    </button>
  );
};

export default TriloChatCopyButton;
